import { render, staticRenderFns } from "./ItemUpdateDialogStockState.vue?vue&type=template&id=ccdf06fe&scoped=true"
import script from "./ItemUpdateDialogStockState.vue?vue&type=script&lang=ts"
export * from "./ItemUpdateDialogStockState.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdf06fe",
  null
  
)

export default component.exports